import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../../../utils/api";
import { Button } from "../../../../components/ui/button";
import { Input } from "../../../../components/ui/input";
import { Label } from "../../../../components/ui/label";
import { Textarea } from "../../../../components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../../components/ui/select";
import { useToast } from "../../../../contexts/ToastContext";

// function AdditionalInfoRequestedForm({ 
//   applicationId: propApplicationId,
//   rounds: propRounds, // ✅ ADD: Receive rounds as prop
//   onUpdate, // ✅ ADD: Receive update callback
// }){
//   const { showToast } = useToast();
//   const { id: routeId } = useParams();

//   // ✅ Use prop if available, otherwise use route param
//   const applicationId = propApplicationId || routeId;

//   const [rounds, setRounds] = useState([]);
//   const [formValues, setFormValues] = useState({});
//   const [files, setFiles] = useState({});
//   const [submittingRoundId, setSubmittingRoundId] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // useEffect(() => {
//   //   if (applicationId) {
//   //     fetchAdditionalInfoRounds();
//   //   }
//   // }, [applicationId]);

//   useEffect(() => {
//     // Only fetch if we don't have prop rounds
//     if (applicationId && !propRounds) {
//       fetchAdditionalInfoRounds();
//     }
//   }, [applicationId, propRounds]);


//   // ✅ Extract initialization logic
//   const initializeFormValues = (roundsList) => {
//     const initVals = {};
//     const initFiles = {};
//     roundsList.forEach((r) => {
//       if (isPending(r.status)) {
//         initVals[r.id] = {};
//         initFiles[r.id] = {};
//         (r.fields || []).forEach((f) => {
//           initVals[r.id][f.key] = "";
//           initFiles[r.id][f.key] = null;
//         });
//       }
//     });
//     setFormValues(initVals);
//     setFiles(initFiles);
//   };

//   /* ---------------- Fetch Additional Info Rounds ---------------- */
//   const fetchAdditionalInfoRounds = async () => {
//     setLoading(true);
//     try {
//       const res = await api.userGetAdditionalInfoRounds(applicationId);
//       const list = Array.isArray(res.data?.rounds) ? res.data.rounds : [];
//       setRounds(list);

//       // initialize form values per round (only for open/pending)
//       const initVals = {};
//       const initFiles = {};
//       list.forEach((r) => {
//         if (isPending(r.status)) {
//           initVals[r.id] = {};
//           initFiles[r.id] = {};
//           (r.fields || []).forEach((f) => {
//             initVals[r.id][f.key] = "";
//             initFiles[r.id][f.key] = null;
//           });
//         }
//       });
//       setFormValues(initVals);
//       setFiles(initFiles);
//     } catch (e) {
//       console.error("Error fetching additional info rounds:", e);
//       setRounds([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isPending = (status) =>
//     ["open", "pending"].includes(String(status).toLowerCase());


//   const handleTextChange = (roundId, key, value) => {
//     setFormValues((prev) => ({
//       ...prev,
//       [roundId]: { ...(prev[roundId] || {}), [key]: value },
//     }));
//   };

//   const handleFileChange = (roundId, key, file) => {
//     setFiles((prev) => ({
//       ...prev,
//       [roundId]: { ...(prev[roundId] || {}), [key]: file || null },
//     }));
//   };

//   const handleSubmitRound = async (round) => {
//     try {
//       setSubmittingRoundId(round.id);
//       const formData = new FormData();

//       // JSON PAYLOAD (text fields)
//       const payload = { ...(formValues[round.id] || {}) };
//       formData.append("payload", JSON.stringify(payload));

//       // FILE FIELDS
//       const fileMap = files[round.id] || {};
//       (round.fields || []).forEach((field) => {
//         if (field.type === "file") {
//           const file = fileMap[field.key];
//           if (!file) return;
//           if (!(file instanceof File)) {
//             console.error("[ERROR] Not a File object:", file);
//             return;
//           }
//           formData.append(field.key, file);
//         }
//       });

//       await api.userSubmitAdditionalInfo(
//         round.application_id || applicationId,
//         round.id,
//         formData,
//       );

//       showToast("Information submitted successfully!", "success");
//       // await fetchAdditionalInfoRounds();
//        // ✅ Call onUpdate callback if provided, otherwise fetch locally
//       if (onUpdate) {
//         await onUpdate();
//       } else {
//         await fetchAdditionalInfoRounds();
//       }
//     } catch (e) {
//       console.error("Submission error:", e);
//       showToast(e.response?.data?.detail || "Submission failed", "error");
//     } finally {
//       setSubmittingRoundId(null);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center p-8">
//         <div className="animate-spin h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full"></div>
//       </div>
//     );
//   }

//   if (!applicationId) {
//     return (
//       <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
//         <p className="text-sm text-yellow-800">
//           Application ID not found. Cannot load additional information requests.
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-8">
//       {rounds.length === 0 && (
//         <div className="text-center py-8">
//           <p className="text-sm text-gray-500">
//             No additional information requested at this time.
//           </p>
//         </div>
//       )}

//       {rounds.map((round, index) => {
//         const pending = isPending(round.status);
//         const roundValues = formValues[round.id] || {};
//         const fields = round.fields || [];

//         return (
//           <div key={round.id} className="border-b pb-6 last:border-b-0">
//             {/* Header */}
//             <div className="flex justify-between items-center mb-3">
//               <h4 className="text-base font-semibold text-gray-900">
//                 Request {index + 1}
//               </h4>
            
//             </div>

//             {round.note_to_applicant && (
//               <p className="text-sm text-gray-600 mb-4">
//                 {round.note_to_applicant}
//               </p>
//             )}

//             {/* Pending form */}
//             {pending && (
//               <div className="space-y-4">
//                 {fields.map((field, fieldIndex) => {
//                   const key = field.key;
//                   const type = String(field.type || "").toLowerCase();
//                   const isLastField = fieldIndex === fields.length - 1;

//                   return (
//                     <div key={key}>
//                       <div className="flex gap-3 items-end">
//                         <div className="flex-1 space-y-1.5">
//                           <Label className="text-sm font-medium text-gray-700">
//                             {field.label}
//                             {field.required && (
//                               <span className="text-red-500 ml-1">*</span>
//                             )}
//                           </Label>

//                           {field.description && (
//                             <p className="text-xs text-gray-500 mb-1">
//                               {field.description}
//                             </p>
//                           )}

//                           {(type === "textbox" || type === "text") && (
//                             <Input
//                               value={roundValues[key] || ""}
//                               onChange={(e) =>
//                                 handleTextChange(round.id, key, e.target.value)
//                               }
//                               placeholder={field.placeholder || ""}
//                               className="text-sm"
//                             />
//                           )}

//                           {type === "textarea" && (
//                             <Textarea
//                               rows={3}
//                               value={roundValues[key] || ""}
//                               onChange={(e) =>
//                                 handleTextChange(round.id, key, e.target.value)
//                               }
//                               placeholder={field.placeholder || ""}
//                               className="text-sm"
//                             />
//                           )}

//                           {type === "dropdown" &&
//                             Array.isArray(field.dropdown_options) && (
//                               <Select
//                                 value={roundValues[key] || ""}
//                                 onValueChange={(val) =>
//                                   handleTextChange(round.id, key, val)
//                                 }
//                               >
//                                 <SelectTrigger className="text-sm">
//                                   <SelectValue placeholder="Select option" />
//                                 </SelectTrigger>
//                                 <SelectContent>
//                                   {field.dropdown_options.map((opt) => (
//                                     <SelectItem key={opt} value={opt}>
//                                       {opt}
//                                     </SelectItem>
//                                   ))}
//                                 </SelectContent>
//                               </Select>
//                             )}

//                           {type === "file" && (
//                             <div className="space-y-1.5">
//                               <Input
//                                 type="file"
//                                 onChange={(e) =>
//                                   handleFileChange(
//                                     round.id,
//                                     key,
//                                     e.target.files?.[0] || null,
//                                   )
//                                 }
//                                 accept={field.accept || "*"}
//                                 className="text-sm"
//                               />
//                               {files[round.id]?.[key] && (
//                                 <p className="text-xs text-green-600">
//                                   ✓ {files[round.id][key].name}
//                                 </p>
//                               )}
//                             </div>
//                           )}
//                         </div>

//                         {/* Submit button only on last field */}
//                         {isLastField && (
//                           <Button
//                             className="bg-blue-600 text-white hover:bg-blue-700"
//                             onClick={() => handleSubmitRound(round)}
//                             disabled={submittingRoundId === round.id}
//                             size="sm"
//                           >
//                             {submittingRoundId === round.id
//                               ? "Submitting…"
//                               : "Submit"}
//                           </Button>
//                         )}
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             )}

//             {/* Read-only submitted response */}
//             {!pending &&
//               round.user_response &&
//               Object.keys(round.user_response).length > 0 && (
//                 <div className="bg-gray-50 rounded p-3 space-y-2 mt-4">
//                   <p className="text-xs font-semibold text-gray-700 mb-2">
//                     Your Submitted Response:
//                   </p>
//                   {Object.entries(round.user_response).map(([k, v]) => (
//                     <div key={k}>
//                       <p className="text-xs text-gray-500 font-medium mb-0.5">
//                         {k.replace(/_/g, " ").toUpperCase()}
//                       </p>
//                       {typeof v === "string" && v.startsWith("http") ? (
//                         <a
//                           href={v}
//                           target="_blank"
//                           rel="noreferrer"
//                           className="text-blue-600 hover:text-blue-800 underline text-sm inline-flex items-center gap-1"
//                         >
//                           <span>View File</span>
//                           <svg
//                             className="w-3 h-3"
//                             fill="none"
//                             stroke="currentColor"
//                             viewBox="0 0 24 24"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
//                             />
//                           </svg>
//                         </a>
//                       ) : (
//                         <p className="text-sm text-gray-800">
//                           {String(v || "-")}
//                         </p>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               )}
//           </div>
//         );
//       })}
//     </div>
//   );
// }


function AdditionalInfoRequestedForm({ 
  applicationId: propApplicationId,
  rounds: propRounds, // ✅ Receive rounds as prop
  onUpdate, // ✅ Receive update callback
}) {
  const { showToast } = useToast();
  const { id: routeId } = useParams();

  const applicationId = propApplicationId || routeId;

  // ✅ Use prop rounds if available, otherwise use local state
  const [localRounds, setLocalRounds] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [files, setFiles] = useState({});
  const [submittingRoundId, setSubmittingRoundId] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Determine which rounds to use
  const rounds = propRounds || localRounds;

  // ✅ Initialize form values when rounds change
  useEffect(() => {
    if (rounds && rounds.length > 0) {
      initializeFormValues(rounds);
    }
  }, [rounds]);

  // ✅ Only fetch if we don't have prop rounds AND we have an applicationId
  useEffect(() => {
    if (applicationId && !propRounds) {
      fetchAdditionalInfoRounds();
    }
  }, [applicationId, propRounds]);

  // ✅ Extract initialization logic
  const initializeFormValues = (roundsList) => {
    const initVals = {};
    const initFiles = {};
    roundsList.forEach((r) => {
      if (isPending(r.status)) {
        initVals[r.id] = {};
        initFiles[r.id] = {};
        (r.fields || []).forEach((f) => {
          initVals[r.id][f.key] = "";
          initFiles[r.id][f.key] = null;
        });
      }
    });
    setFormValues(initVals);
    setFiles(initFiles);
  };

  const fetchAdditionalInfoRounds = async () => {
    setLoading(true);
    try {
      const res = await api.userGetAdditionalInfoRounds(applicationId);
      const list = Array.isArray(res.data?.rounds) ? res.data.rounds : [];
      setLocalRounds(list);
    } catch (e) {
      console.error("Error fetching additional info rounds:", e);
      setLocalRounds([]);
    } finally {
      setLoading(false);
    }
  };

  const isPending = (status) =>
    ["open", "pending"].includes(String(status).toLowerCase());

  const handleTextChange = (roundId, key, value) => {
    setFormValues((prev) => ({
      ...prev,
      [roundId]: { ...(prev[roundId] || {}), [key]: value },
    }));
  };

  const handleFileChange = (roundId, key, file) => {
    setFiles((prev) => ({
      ...prev,
      [roundId]: { ...(prev[roundId] || {}), [key]: file || null },
    }));
  };

  const handleSubmitRound = async (round) => {
    try {
      setSubmittingRoundId(round.id);
      const formData = new FormData();

      const payload = { ...(formValues[round.id] || {}) };
      formData.append("payload", JSON.stringify(payload));

      const fileMap = files[round.id] || {};
      (round.fields || []).forEach((field) => {
        if (field.type === "file") {
          const file = fileMap[field.key];
          if (!file) return;
          if (!(file instanceof File)) {
            console.error("[ERROR] Not a File object:", file);
            return;
          }
          formData.append(field.key, file);
        }
      });

      await api.userSubmitAdditionalInfo(
        round.application_id || applicationId,
        round.id,
        formData,
      );

      showToast("Information submitted successfully!", "success");
      
      // ✅ Call onUpdate callback if provided, otherwise fetch locally
      if (onUpdate) {
        await onUpdate();
      } else {
        await fetchAdditionalInfoRounds();
      }
    } catch (e) {
      console.error("Submission error:", e);
      showToast(e.response?.data?.detail || "Submission failed", "error");
    } finally {
      setSubmittingRoundId(null);
    }
  };

  // ✅ Only show loading if we're actually fetching (not when using prop rounds)
  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="animate-spin h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  if (!applicationId) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <p className="text-sm text-yellow-800">
          Application ID not found. Cannot load additional information requests.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      {rounds.length === 0 && (
        <div className="text-center py-8">
          <p className="text-sm text-gray-500">
            No additional information requested at this time.
          </p>
        </div>
      )}

      {rounds.map((round, index) => {
        const pending = isPending(round.status);
        const roundValues = formValues[round.id] || {};
        const fields = round.fields || [];

        return (
          <div key={round.id} className="border-b pb-6 last:border-b-0">
            {/* Header */}
            <div className="flex justify-between items-center mb-3">
              <h4 className="text-base font-semibold text-gray-900">
                Request {index + 1}
              </h4>
            </div>

            {round.note_to_applicant && (
              <p className="text-sm text-gray-600 mb-4">
                {round.note_to_applicant}
              </p>
            )}

            {/* Pending form */}
            {pending && (
              <div className="space-y-4">
                {fields.map((field, fieldIndex) => {
                  const key = field.key;
                  const type = String(field.type || "").toLowerCase();
                  const isLastField = fieldIndex === fields.length - 1;

                  return (
                    <div key={key}>
                      <div className="flex gap-3 items-end">
                        <div className="flex-1 space-y-1.5">
                          <Label className="text-sm font-medium text-gray-700">
                            {field.label}
                            {field.required && (
                              <span className="text-red-500 ml-1">*</span>
                            )}
                          </Label>

                          {field.description && (
                            <p className="text-xs text-gray-500 mb-1">
                              {field.description}
                            </p>
                          )}

                          {(type === "textbox" || type === "text") && (
                            <Input
                              value={roundValues[key] || ""}
                              onChange={(e) =>
                                handleTextChange(round.id, key, e.target.value)
                              }
                              placeholder={field.placeholder || ""}
                              className="text-sm"
                            />
                          )}

                          {type === "textarea" && (
                            <Textarea
                              rows={3}
                              value={roundValues[key] || ""}
                              onChange={(e) =>
                                handleTextChange(round.id, key, e.target.value)
                              }
                              placeholder={field.placeholder || ""}
                              className="text-sm"
                            />
                          )}

                          {type === "dropdown" &&
                            Array.isArray(field.dropdown_options) && (
                              <Select
                                value={roundValues[key] || ""}
                                onValueChange={(val) =>
                                  handleTextChange(round.id, key, val)
                                }
                              >
                                <SelectTrigger className="text-sm">
                                  <SelectValue placeholder="Select option" />
                                </SelectTrigger>
                                <SelectContent>
                                  {field.dropdown_options.map((opt) => (
                                    <SelectItem key={opt} value={opt}>
                                      {opt}
                                    </SelectItem>
                                  ))}
                                </SelectContent>
                              </Select>
                            )}

                          {type === "file" && (
                            <div className="space-y-1.5">
                              <Input
                                type="file"
                                onChange={(e) =>
                                  handleFileChange(
                                    round.id,
                                    key,
                                    e.target.files?.[0] || null,
                                  )
                                }
                                accept={field.accept || "*"}
                                className="text-sm"
                              />
                              {files[round.id]?.[key] && (
                                <p className="text-xs text-green-600">
                                  ✓ {files[round.id][key].name}
                                </p>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Submit button only on last field */}
                        {isLastField && (
                          <Button
                            className="bg-blue-600 text-white hover:bg-blue-700"
                            onClick={() => handleSubmitRound(round)}
                            disabled={submittingRoundId === round.id}
                            size="sm"
                          >
                            {submittingRoundId === round.id
                              ? "Submitting…"
                              : "Submit"}
                          </Button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Read-only submitted response */}
            {!pending &&
              round.user_response &&
              Object.keys(round.user_response).length > 0 && (
                <div className="bg-gray-50 rounded p-3 space-y-2 mt-4">
                  <p className="text-xs font-semibold text-gray-700 mb-2">
                    Your Submitted Response:
                  </p>
                  {Object.entries(round.user_response).map(([k, v]) => (
                    <div key={k}>
                      <p className="text-xs text-gray-500 font-medium mb-0.5">
                        {k.replace(/_/g, " ").toUpperCase()}
                      </p>
                      {typeof v === "string" && v.startsWith("http") ? (
                        <a
                          href={v}
                          target="_blank"
                          rel="noreferrer"
                          className="text-blue-600 hover:text-blue-800 underline text-sm inline-flex items-center gap-1"
                        >
                          <span>View File</span>
                          <svg
                            className="w-3 h-3"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                            />
                          </svg>
                        </a>
                      ) : (
                        <p className="text-sm text-gray-800">
                          {String(v || "-")}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              )}
          </div>
        );
      })}
    </div>
  );
}

export default AdditionalInfoRequestedForm;